import { moveOnVector, nameShape } from ".."
import type { Face2dComputed, Edge2dComputed, Edge2d } from "../../mesh"
import { angleInto } from "../../mesh/angleFromPolygonEdge"

export type GetInsetEdge = (options: {
  area: Face2dComputed
  edge: Edge2dComputed & { setback: number }
}) => Edge2dComputed

export const getInsetEdge: GetInsetEdge = ({ area, edge }) => {
  const rotation = angleInto(area).from(edge)
  const inward = { d: edge.setback, r: rotation }

  return {
    p1: moveOnVector(inward).point(edge.p1),
    p2: moveOnVector(inward).point(edge.p2),
  }
}

export type InsetEdge = Edge2dComputed & {
  originalIdx: number
  originalId: string
  original: Edge2dComputed & { setback: number }
  type: "inset"
}

export type GetInsetEdges = (options: {
  area: Face2dComputed
  edges: (Edge2d & Edge2dComputed & { setback: number })[]
}) => InsetEdge[]

export const getInsetEdges: GetInsetEdges = ({ area, edges }) =>
  edges
    .map((edge) => getInsetEdge({ area, edge }))
    .map((edge, idx) => {
      const { node1id, node2id } = edges[idx]

      return {
        ...edge,
        originalIdx: idx,
        originalId: nameShape(node1id, node2id),
        original: edges[idx],
        type: `inset`,
      }
    })
